import { BaseButtons, sx } from '@lucan/base-ui'

export default function BottoneIndietro(props) {
  const { ...rest } = props

  return (
    <BaseButtons.MenoDettagli
      variant='text'
      {...rest}
      {...sx(rest, { p: 0 })}
    />
  )
}